import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tdf'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'tdf_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'tdf_dashboard', params: to.params };
          },
        },
        {
          path: 'dashboard',
          name: 'tdf_dashboard',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'dashboard' } },
        },
        {
          path: 'reception',
          name: 'tdf_reception',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'reception' } },
        },
        {
          path: 'reservations',
          name: 'tdf_reservations',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'reservations' } },
        },
        {
          path: 'direct-sales',
          name: 'tdf_direct_sales',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'direct-sales' } },
        },
        {
          path: 'clients',
          name: 'tdf_clients',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'clients' } },
        },
        {
          path: 'admin',
          name: 'tdf_admin',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'admin' } },
        },
        {
          path: 'other-routines',
          name: 'tdf_other_routines',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'other-routines' } },
        },
        {
          path: 'units',
          name: 'tdf_units',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'units' } },
        },
        {
          path: 'config',
          name: 'tdf_config',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'config' } },
        },
      ],
    },
  ],
};
